import { createIcon } from '@chakra-ui/react'

export const SignOut = createIcon({
  displayName: 'SignOut',
  viewBox: '0 0 19 19',
  d: 'M13.6667 5.52381L12.391 6.79952L13.8205 8.23809H6.42857V10.0476H13.8205L12.391 11.4771L13.6667 12.7619L17.2857 9.14286L13.6667 5.52381ZM2.80952 2.80952H9.14286V1H2.80952C1.81429 1 1 1.81429 1 2.80952V15.4762C1 16.4714 1.81429 17.2857 2.80952 17.2857H9.14286V15.4762H2.80952V2.80952Z',
})
